import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('msg_error_required_field'),
  email: Yup.string().trim().email('msg_error_invalid_email_format').nullable(),
});
